export { default } from './EykoSidebarLogo';
